import React from 'react'

/**
 * This will will override our components in showing the best of 2024 label if set to false
 */
const BestOfLabelContext = React.createContext<boolean>(true)

export default BestOfLabelContext
